import templateCompiler from './template.art';
import {
    HELP_MAP,
    // FILE_PROPERTIES_GROUP_IN_HOME
} from "../constants/help.constants";
import { isCNDomain } from 'Utils/utils';
import { isDTRuntime } from '@/modules/3rd-party-integration/utils/env';
const template = templateCompiler({ ...HELP_MAP, isDTRuntime });
export default function HelpModule(callback, isOnPremiseDeployMode) {
    if (isOnPremiseDeployMode) {
      let fragments = [];
      return { fragments };
    }

    let insertTarget = isCNDomain() ? 'wrap-esignCN-tab' : 'wrap-foxitESign-tab';
    let ACTIONS = window.UIExtension.UIConsts.FRAGMENT_ACTION;
    let fragments = [
        {
            // 向末尾追加控件
            action: ACTIONS.AFTER,
            // 目标控件名称， 控件将被添加这个空间里面，必须确保它是一个容器类型的控件
            target: insertTarget,
            // 定义控件的以及图标，文字等信息
            template: '<gtab text="phantom_online:toolbar.tabs.help.title" name="help-tab" group="toolbar-tab" body="fv--help-tab-paddle" @portfolio.unsupport></gtab>',
        },
        {
            action: ACTIONS.APPEND,
            target: 'toolbar-tab-bodies',
            template: template,
        },
      // {
      //   // to remove 'file-properties' group which is in home tab
      //   action: ACTIONS.REMOVE,
      //   target: FILE_PROPERTIES_GROUP_IN_HOME
      // }
    ];
    return {fragments};
}